import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { siteConfig } from '@/constants/site'

export const HomeIntro: FC = (): ReactNode => {
    return (
        <div className='hm-intro'>
            <p className='eyebrow hm-intro-eyebrow'>
                {siteConfig.fullName}
            </p>

            <h1 className='hm-intro-title'>
                Nove formas de violência
            </h1>

            <p className='hm-intro-deck'>
                Gire o anel e escolha uma esfera para entender, reconhecer e saber como agir.
            </p>

            <Link href='/violencias' className='hm-intro-link'>
                <span>
                    Ver a lista completa
                </span>
            </Link>
        </div>
    )
}
